import { render, staticRenderFns } from "./ItalicIcon.vue?vue&type=template&id=221a0d7a&"
import script from "./ItalicIcon.vue?vue&type=script&lang=js&"
export * from "./ItalicIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports